@if ((hidden$ | async) === false) {
  @if ((isLoading$ | async) === true) {
    <i class="ficon-spinner ficon-spin ficon-2x loading-spinner"></i>
  }
  @if ((isLoading$ | async) !== true) {
    @if (((config.promptAction || config.secondaryLink) && !hasStoredKey)) {
      <div class="button-view">
        @if (config.titleTranslationKey) {
          <div id="tease-wall-title">{{config.titleTranslationKey | translate}}</div>
        }
        @if (config.promptAction) {
          <button
            (click)="buttonClicked()"
            type="submit"
            class="primary-btn"
            [attr.aria-label]="('tease-wall_request-button-aria-label' | translate )+ ', ' +  (translationKey | translate)"
            [disabled]="loading">
            <span [translate]="translationKey"></span>
            @if (loading) {
              <i class="ficon-spinner ficon-spin"></i>
            }
          </button>
        }
        @if (config.secondaryLink) {
          <a
            [attr.aria-label]="'access_denied-learn-more' | translate"
            [attr.href]="config.secondaryLink"
            target="_blank"
            rel="noopener noreferrer"
            class="secondary-link tertiary-btn">
            {{'access_denied-learn-more' | translate}}
          </a>
        }
      </div>
    } @else {
      <div class="text-view">
        @if (config.promptAction && hasStoredKey) {
          <i class="ficon-app-checkmark-circle-outline"></i>
        }
        <p tabindex="0"
          aria-live="polite"
          [attr.aria-label]="('tease-wall_request-button-aria-label' | translate) + ', ' +  (translationKey | translate)"
          [translate]="translationKey">
        </p>
      </div>
    }
  }
}
